<template>
  <!-- Mobile menu bar -->
  <div
    class="flex items-center justify-between border-b border-gray-100 bg-white px-6"
  >
    <RouterLink :to="{ name: 'dashboard' }" class="logo cursor-pointer">
      <logoSvg class="h-16 w-48 fill-primary" />
    </RouterLink>
    <BaseButton color="subtle" square @click="emit('openMenu')">
      <BaseIcon class="text-primary" name="menu" />
    </BaseButton>
  </div>
</template>

<script setup>
import { computed, defineAsyncComponent } from "vue"
import { BaseIcon, BaseButton } from "@repowerednl/ui-component-library"

const emit = defineEmits(["openMenu"])

const logoSvg = computed(() => {
  return defineAsyncComponent(() => import(`/src/assets/repowered-logo.svg`))
})
</script>
